import React from "react";
import MainApp from './MainApp';
import './App.css';

const App = () => {
  return <MainApp />;
};

export default App;
